import request from "@/utils/request";


// 发送规则
export function getSendRule(params) {
  return request.post('/crm/requestRule', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

// 请求规则总计统计
export function summaryPage(params) {
  return request.post('/crm/requestRule/summaryPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function editSendRuleStatus(params) {
  return request.put('/crm/requestRule/batchUpdateStatus', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}


export function mailHover(id) {
  return request.get(`/crm/requestRule/mailHover/${id}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function addSendRule(params) {
  return request.post('/crm/requestRule/add', params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function updateSendRule(params) {
  return request.put('/crm/requestRule/update', params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function getSystemTime(country, hour) {
  return request.get(`/crm/requestRule/localTime/${country}/${hour}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function getSendRuleDetail(id) {
  return request.get(`/crm/requestRule/${id}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function getSendRuleLog(params) {
  return request.post(`/crm/requestRule/logs`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 发送记录
export function getSendRecord(params) {
  return request.post(`/crm/requestRecord`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 邮件模板
export function getMailTemplatePage(params) {
  return request.post(`/crm/mailTemplate`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function deleteTemplate(id) {
  return request.delete(`crm/mailTemplate/${id}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function batchDeleteTemplate(ids) {
  return request.delete(`crm/mailTemplate/batchDelete`, { data: ids })
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function addMailTemplate(params) {
  return request.post(`/crm/mailTemplate/add`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}
//邮件模板变量
export function getTemplateType() {
  return request.get(`/crm/mailTemplate/getTemplateType`)
    .then((res) => {
      return Promise.resolve(res)
    });
}
//邮件模板类型下拉框
export function getMailTemplateVariable() {
  return request.get(`/crm/mailTemplate/queryMailTemplateVariable`)
    .then((res) => {
      return Promise.resolve(res)
    });
}

// 获取回复邮件模板
export function getMailTemplateList(params) {
  return request.post(`/crm/mailTemplate/templateList`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

//获取邮件回复模板
export function marketEmailTemplate(marketId) {
  return request.get(`/crm/mailTemplate/templates?marketId=${marketId}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function updateMailTemplate(params) {
  return request.put(`/crm/mailTemplate`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

// 邮件授权
export function unbindEmail(id) {
  return request.post(`crm/email/${id}/unbind`)
    .then((res) => {
      return Promise.resolve(res)
    });
}

export function bindNewEmail(params) {
  return request.post(`/crm/email/bindNew`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

export function bindExistEmail(params) {
  return request.post(`/crm/email/bindExist`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

export function sameSellerEmails(marketId) {
  return request.get(`/crm/email/sameSellerEmails?marketId=${marketId}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function updateEmail(params) {
  return request.post(`/crm/email/update`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

// 邮件回复
export function getMailReplyQuantity(id) {
  return request.get(`/crm/ticket/ticketQuantity?marketId=${id}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function syncMailMessage(marketId) {
  return request.put(`/crm/ticket/syncMailMessage?marketId=${marketId}`)
    .then((res) => {
      return Promise.resolve(res)
    });
}

export function getMailList(params) {
  return request.post(`/crm/ticket`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 根据feedback 查询 邮件详情
export function getResolveBadComment(params) {
  return request.get(`/crm/feedback/resolveBadComment`, { params })
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

//买家邮件详情
export function getBuyerEmailDetail(id) {
  return request.get(`/crm/ticket/buyerEmailDetail/${id}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

//邮件设置匹配类型
export function updateMatchResult(matchResult, relateOrderId) {
  return request.put(`/crm/reviewRelateOrder/updateMatchResult?matchResult=${matchResult}&relateOrderId=${relateOrderId}`)
    .then((res) => {
      return Promise.resolve(res)
    });
}


export function batchUpdateStatus(params) {
  return request.put(`/crm/ticket/batchUpdateStatus`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

export function updateStatus(id, status) {
  return request.put(`/crm/ticket/updateStatus/${id}/${status}`,)
    .then((res) => {
      return Promise.resolve(res)
    });
}

export function updateCrmMemo(params) {
  return request.put(`/crm/ticket/updateMemo`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function sendMail(params) {
  return request.post(`/crm/ticket/send`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

export function getQAEmailDetail(id) {
  return request.get(`/crm/ticket/qaDetail/${id}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function getAmazonEmailDetail(id) {
  return request.get(`/crm/ticket/amazonEmailDetail/${id}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 获取站点对应邮箱账号
export function getEmailAccountCombobox() {
  return request.get(`/crm/ticket/getEmailAccountCombobox`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 获取站点对应邮箱账号 v2.0.0
export function getMarketCombobox() {
  return request.get(`/crm/ticket/marketCombobox`)
      .then((res) => {
          return Promise.resolve(res.data)
      });
}

// 获取不同类型邮件的未读数量
export function getNotReadNumByStatus(marketId) {
  return request.get(`/crm/ticket/getNotReadNumByStatus?marketId=${marketId}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}
// 获取不同类型邮件的未读数量
export function getPendingNumByStatus(marketId, status) {
  return request.get(`/crm/ticket/getPendingNumByStatus?marketId=${marketId}&status=${status}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 获取不同类型待处理或未读的邮件数量 v2.0.0
export function ticketNum(params) {
  return request.post(`/crm/ticket/ticketNum`, params)
      .then((res) => {
          return Promise.resolve(res.data)
      });
}

// 获取不同类型待处理或未读的邮件数量 v2.0.0
export function ticketSendStatus(params) {
  return request.post(`/crm/ticket/ticketSendStatus`, params)
      .then((res) => {
          return Promise.resolve(res.data)
      });
}

// 邮件归档 NR
export function archiveOrder(params) {
  return request.post(`/crm/reviewRelateOrder/archiveOrder`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

// 邮件归档 NF
export function archive(id, lastResult, lastStar) {
  return request.put(`/crm/feedback/archive?id=${id}&lastResult=${lastResult}&lastStar=${lastStar}`)
    .then((res) => {
      return Promise.resolve(res)
    });
}


// 站外邮件
export function outTicketItemDraftsDetail(id) {
  return request.get(`/crm/outTicketItem/outTicketItemDraftsDetail/${id}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

export function outEmailList(params) {
  return request.get(`/crm/outTicketItem/outEmailList`)
    .then((res) => {
      return Promise.resolve(res)
    });
}
export function outTicketItemList(params) {
  return request.post(`/crm/outTicketItem/outTicketItemList`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}
export function getOutTicketItemDetail(id) {
  return request.get(`/crm/outTicketItem/outTicketItemDetail/${id}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}
export function getAllTemplateList(params) {
  return request.post('/crm/mailTemplate/templateList', params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}
export function handleOutTicketItemCollection(params) {
  return request.post('/crm/outTicketItem/outTicketItemCollection', params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}
export function outTicketItemDraftSave(params) {
  return request.post('/crm/outTicketItem/outTicketItemSave', params).then((res) => {
    return Promise.resolve(res.data)
  });
}
export function outTicketItemReaded(id) {
  return request.get(`/crm/outTicketItem/outTicketItemReaded/${id}`).then((res) => {
    return Promise.resolve(res.data)
  });
}
export function outTicketItemReadAll(parmas) {
  return request.post(`/crm/outTicketItem/outTicketItemReadAll`, parmas).then((res) => {
    return Promise.resolve(res.data)
  });
}
export function getActiveTreeTag() {
  return request.get(`/crm/tag/getActiveTreeTag`).then((res) => {
    return Promise.resolve(res.data)
  });
}
export function outTicketItemSend(parmas) {
  return request.post(`/crm/outTicketItem/outTicketItemSend`, parmas).then((res) => {
    return Promise.resolve(res.data)
  });
}
export function outTicketItemResend(id) {
  return request.get(`/crm/outTicketItem/outTicketItemResend/${id}`).then((res) => {
    return Promise.resolve(res.data)
  });
}

export function outTicketItemUnread() {
  return request.get(`/crm/outTicketItem/outTicketItemUnread`).then((res) => {
    return Promise.resolve(res.data)
  });
}


//请求规则
// 查询邮件模板的变量
export function queryMailTemplateVariable() {
  return request.get(`/crm/mailTemplate/queryMailTemplateVariable`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}


// 运营-获取商品接口
export function simpleListings(params) {
  return request.post(`/operation/listing/simpleListings`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}


// 获取邮件模板列表
export function templateList(params) {
  return request.post(`crm/mailTemplate/templateList`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}


// 校验请求规则名称
export function validateSameName(params) {
  return request.get(`/crm/requestRule/validateSameName`, {params})
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 查询符合规则的订单列表
export function listOrderListView(params) {
  return request.post(`/crm/requestRule/orderListView`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}


// 新增请求规则
export function requestRuleAdd(params) {
  return request.post(`/crm/requestRule/add`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 邮件加油包额度展示
export function mailPack() {
  return request.get(`/crm/requestRule/mailPack`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 预览邮件
export function mailPreview(params) {
  return request.post(`/crm/requestRule/mailPreview`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}



// 预览邮件查询订单
export function getOrderInfo(orderId) {
  return request.get(`/crm/requestRule/getOrderInfo/${orderId}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}


// 详情
export function requestRuleDetal(orderId) {
  return request.get(`/crm/requestRule/${orderId}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 统计未执行规则数量
export function countNotExecuteRecord(params) {
  return request.post(`/crm/requestRule/countNotExecuteRecord`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 更新请求规则状态
export function requestRuleDetalStatus(orderId) {
  return request.get(`/crm/requestRule/${orderId}${status}`)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 全部标记为已读
export function markAllRead(params) {
  return request.get(`/crm/ticket/markAllRead`, {params})
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 消息失败提醒 我知道了，不再提醒
export function remindIgnore(params) {
  return request.get(`/crm/ticket/remindIgnore`, {params})
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 邮件重新发送
export function resendAgainEmail(params) {
  return request.get(`/crm/ticket/resendAgainEmail`, {params})
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 重要邮件邮件任务列表
export function ticketCollection(params) {
  return request.post(`crm/ticketCollection`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

// 邮件加入-取消重要邮件
export function setTicketCollection(params) {
  return request.post(`crm/ticketCollection/ticketCollection`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

//站外邮件授权
export function bindNewOutEmail(params) {
  return request.post(`/email/bindNewOut`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

//分页查询站外邮箱
export function getOutEmailPageList(params) {
  return request.post(`/crm/email/outEmailPage`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    });
}

//分页查询站外邮箱操作日志
export function getEmailLogPageList(params) {
  return request.post(`/crm/email/emailLogPage`, params)
  .then((res) => {
    return Promise.resolve(res.data)
  });
}

//绑定站外新邮箱
export function bindNewOut(params) {
  return request.post(`/crm/email/bindNewOut`, params)
  .then((res) => {
    return Promise.resolve(res)
  });
}

//更新站外邮箱
export function updateOutEmail(params) {
  return request.post(`/crm/email/updateOutEmail`, params)
    .then((res) => {
      return Promise.resolve(res)
    });
}

//关怀邮件批量重新发送
export function resendCareEmail(params) {
  return request.post(`/crm/ticket/batchResendAgain`, params)
  .then((res) => {
    return Promise.resolve(res)
  });
}
